import { unref, computed } from 'vue'

/**
 * ユーザーリスト表示項目(プレイス)の利用
 * @param {MaybeRef.<string>} placeName プレイス名
 */
export function useUserStatusAdditionalItemPlace({ placeName }) {
  /**
   * プレイス表示テキスト
   * @type {ComputedRef.<string>}
   */
  const text = computed(() => {
    const name = unref(placeName)
    return name == null ? '-' : name
  })

  return { text }
}
